export const CHANNELS = {
  speed: { label: 'Speed', unit: 'MPH', color: '#2e86c1', lowerBoundMode: 'tenPercentBelowMinOrZeroIfNegative', headroom: 0.05, enabled: true },
  lateralG: { label: 'Lateral G', unit: 'G', color: '#e74c3c', headroom: 0.08, enabled: true },
  longG: { label: 'Long G', unit: 'G', color: '#27ae60', headroom: 0.08, enabled: true },
  // Hidden channels - enable later
  rpm: { label: 'RPM', unit: 'rpm', color: '#f39c12', lowerBoundMode: 'tenPercentBelowMinOrZeroIfNegative', headroom: 0.05, enabled: false, integer: true },
  throttle: { label: 'Throttle', unit: '%', color: '#2ecc71', preferZeroMin: true, headroom: 0.05, enabled: false, integer: true },
  brake: { label: 'Brake Pressure', unit: 'PSI', color: '#e74c3c', preferZeroMin: true, headroom: 0.10, enabled: false },
  gear: { label: 'Gear', unit: '', color: '#9b59b6', preferZeroMin: true, headroom: 0.1, enabled: false, integer: true },
  steering: { label: 'Steering', unit: 'deg', color: '#1abc9c', headroom: 0.08, enabled: false },
  waterTemp: { label: 'Water Temp', unit: 'F', color: '#3498db', headroom: 0.08, enabled: false },
  oilTemp: { label: 'Oil Temp', unit: 'F', color: '#e67e22', headroom: 0.08, enabled: false },
  oilPressure: { label: 'Oil Pressure', unit: 'PSI', color: '#c0392b', preferZeroMin: true, headroom: 0.08, enabled: false },
  fuelLevel: { label: 'Fuel Level', unit: 'gal', color: '#f1c40f', preferZeroMin: true, headroom: 0.08, enabled: false },
};

export const ACTIVE_CHANNELS = Object.entries(CHANNELS)
  .filter(([, ch]) => ch.enabled)
  .map(([key, ch]) => ({ key, ...ch }));

export const ALL_CHANNELS = Object.entries(CHANNELS)
  .map(([key, ch]) => ({ key, ...ch }));

function applyUserUnits(key, ch, user) {
  if (key === 'speed' && user?.units === 'metric') {
    return { ...ch, unit: 'km/h' };
  }
  return ch;
}

export function getChannel(key, user) {
  const ch = CHANNELS[key];
  if (!ch) return null;
  return { key, ...applyUserUnits(key, ch, user) };
}

export function getActiveChannels(user) {
  return Object.entries(CHANNELS)
    .filter(([, ch]) => ch.enabled)
    .map(([key, ch]) => ({ key, ...applyUserUnits(key, ch, user) }));
}

export function getAllChannels(user) {
  return Object.entries(CHANNELS)
    .map(([key, ch]) => ({ key, ...applyUserUnits(key, ch, user) }));
}

export const DEMO_SESSIONS = [
  {
    sessionId: 'demo-daytona-1',
    track: 'Daytona International Speedway',
    car: 'BMW M4 GT3',
    date: '2026-03-20',
    lapCount: 12,
    bestLap: 78.432,
  },
  {
    sessionId: 'demo-sebring-1',
    track: 'Sebring International Raceway',
    car: 'Porsche 911 GT3 R',
    date: '2026-03-18',
    lapCount: 18,
    bestLap: 119.876,
  },
  {
    sessionId: 'demo-cota-1',
    track: 'Circuit of the Americas',
    car: 'BMW M4 GT3',
    date: '2026-03-15',
    lapCount: 8,
    bestLap: 132.215,
  },
];
